import React from 'react'
import MessageScreen from './MessageScreen'

const MessageCenter = () => {
    return <MessageScreen />
}

export default MessageCenter
